import { useState, useEffect, useRef } from 'react'

interface Size {
    width: number | undefined;
    height: number | undefined;
}

function useWindowSize(): Size {
    const [windowSize, setWindowSize] = useState<Size>({
        width: undefined,
        height: undefined,
    });
    let timer = useRef<ReturnType<typeof setTimeout>|null>(null)

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
        window.addEventListener('resize', () => {
            if(timer.current !== null){
                clearTimeout(timer.current)
            }
            timer.current = setTimeout(() => {
                handleResize()
            }, 200)
        });
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, [])
    return windowSize;
}

export default useWindowSize